<template>
    <div class="phone-slider slider" ref="phoneSlider">
        <carousel-3d
            :perspective="0"
            :display="3"
            :width="isPhone ? 175 : 303"
            :height="isPhone ? 420 : 722"
            :border="0"
            :dir="'ltr'"
            @before-slide-change="onBeforeSlideChange"
            ref="carousel">
            <slide :index="0">
                <img
                    src="https://images.iphonephotographyschool.com/32139/Group-809.png"
                    srcset="https://images.iphonephotographyschool.com/32140/Group-8092x.png 2x"
                    alt="person long shadow" />
            </slide>
            <slide :index="1">
                <img
                    src="https://images.iphonephotographyschool.com/32137/Group-808.png"
                    srcset="https://images.iphonephotographyschool.com/32138/Group-8082x.png 2x"
                    alt="person with a dog" />
            </slide>
            <slide :index="2">
                <img
                    src="https://images.iphonephotographyschool.com/31531/Group-688.png"
                    srcset="https://images.iphonephotographyschool.com/31532/Group-6882x.png 2x"
                    alt="crouching portrait" />
            </slide>
        </carousel-3d>

        <div class="phone-slider__pagination">
            <div
                v-for="(item, i) in 3"
                class="phone-slider__pagination-item"
                :class="{ 'phone-slider__pagination-item--active': current === i }"
                :key="i"
                @click="goToSlide(i)"></div>
        </div>
    </div>
</template>

<script>
import { Carousel3d, Slide } from '@nanoandrew4/vue3-carousel-3d';
import { helpers } from '../../helpers';

export default {
    components: {
        Carousel3d,
        Slide,
    },
    data() {
        return {
            current: 0,
        };
    },
    computed: {
        isPhone() {
            return helpers.isPhone();
        },
    },
    methods: {
        goToSlide(index) {
            this.$refs.carousel.goSlide(index);
        },
        onBeforeSlideChange(index) {
            this.current = index;
        },
    },
};
</script>

<style lang="sass">
.phone-slider
    padding: 80px 0

    &.open
        .carousel-3d-slide
            padding: 20px 0 0 0
            border: none
            background: none
            overflow: visible

            &.current
                img
                    transform: translateY(-5px) rotate(-2deg)

            &.left-1
                transform: translateX(-50px) !important

                @media screen and (min-width: 768px)
                    transform: translateX(-100px) !important

                img
                    transform: rotate(-17deg)

            &.right-1
                transform: translateX(50px) !important

                @media screen and (min-width: 768px)
                    transform: translateX(100px) !important

                img
                    transform: rotate(13deg)

            img
                transition: transform .5s ease

    &__pagination
        display: flex
        align-items: flex-start
        justify-content: center
        gap: 16px

    &__pagination-item
        height: 9px
        width: 9px
        border-radius: 50%
        background: #3A3A3C
        transition: background-color .2s ease-in-out

        &--active
            background: #D9D9D9

    .carousel-3d-container
        margin: 0
        // touch-action: none
        cursor: grab

        &:focus
            cursor: grabbing

    .carousel-3d-slide
        padding: 20px 0 0 0
        background: none
        overflow: visible
        will-change: transform
        transform: none !important

        &.left-1
            z-index: 1000 !important

        img
            transition: transform .5s ease

    .carousel-3d-slider
        transform-style: unset !important
        perspective: none !important
</style>
